<template>
  <comp-data-iterator class="pt-3" :datos="datos" :actions="acciones" :results="params.results" :titleCard="titleCard"/>
</template>

<script>
// Componentes
import { listMixins } from '../settings/functions'

export default {
  mixins: [listMixins],
  data() {
    return {
      titlePage: 'Listado de códigos'
    }
  }
}
</script>
